import { render } from "./panelblock.vue?vue&type=template&id=25153a00&scoped=true&ts=true"
import script from "./panelblock.vue?vue&type=script&lang=ts"
export * from "./panelblock.vue?vue&type=script&lang=ts"

import "./panelblock.vue?vue&type=style&index=0&id=25153a00&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25153a00"]])

export default __exports__